// istanbul ignore file - this file is mostly a wrapper for routing to other features
import { useVariant } from '@calendly/feature-check-react'
import { I18n } from '@calendly/i18n'
import { TitleText } from '@calendly/ui/components/typography'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'

import { useGetPolicyQuery } from 'common'
import LoadingState from 'components/core/loading_state'
import { TabContainer, PageHeaderWithTabs } from 'components/page_elements'
import { SingleSignOn, DomainControl, UserAccess, UserProvisioning } from 'features/organization_settings'
import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context'
import { useMeetingTypesPath } from 'hooks/use_meeting_types_path'

import { generateTabs } from '../helpers'
import { getAdminLoginTabs } from '../settings_section_tabs'

export const LoginPage = ({ match }) => {
  const { pathname } = useLocation()
  const inSettingsModal = useIsSettingsModalLayout()
  const settingsModalShellOwnsTabs = inSettingsModal
  const joinAnOrgEnabled = useVariant('obi_home_new_join_an_org') === 'on'

  const tabs = getAdminLoginTabs(joinAnOrgEnabled)

  const { data: policyData = {}, isFetching: isPolicyFetching } = useGetPolicyQuery()
  const {
    canManageSso,
    canManageUserProvisioning,
    canManageUserAccess,
    canManageDomains
  } = policyData || {}
  const meetingTypesPath = useMeetingTypesPath()

  if (isPolicyFetching) {
    return <LoadingState />
  }

  const routes = (
    <TabContainer narrow>
      <Switch>
        <Redirect from={match.url} to={`${match.url}/sso`} exact />
        {canManageSso && (
          <Route path={`${match.url}/sso`} exact component={SingleSignOn} />
        )}
        {canManageUserProvisioning && (
          <Route path={`${match.url}/user_provisioning`} exact component={UserProvisioning} />
        )}
        {joinAnOrgEnabled
          ? canManageUserAccess && <Route path={`${match.url}/user_access`} exact component={UserAccess} />
          : canManageDomains && <Route path={`${match.url}/domain_control`} exact component={DomainControl} />}
        <Redirect to={meetingTypesPath} />
      </Switch>
    </TabContainer>
  )

  if (settingsModalShellOwnsTabs) {
    return routes
  }

  return (
    <>
      <PageHeaderWithTabs
        hideTitleChrome={inSettingsModal}
        eyebrow={(
          <TitleText variant="eyebrow">
            {I18n.t('publisher.admin.navigation.organization')}
          </TitleText>
        )}
        title={I18n.t('publisher.admin.login.title')}
        tabs={generateTabs({ pathname, tabs })}
      />
      {routes}
    </>
  )
}
